import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SummaryRow, SummaryItem, SummaryBox } from './utils';
import { toDisplayTimeString } from '../../helpers/moment-ex';
import { isPlannedOrTodate, isUUID } from "../../helpers/common";
import { getBaleKPI, clearAnalyzeData } from "../../actions/analyze";

const AnalyzeInfoThree = props => {
    const { params } = props;
    const dispatch = useDispatch();
    const bale = useSelector(state => state.analyze.bale);
    const isRequesting = bale.isRequesting;
    const summary = bale.payload;

    useEffect(() => {
        if (!isUUID(params.crewId) && isPlannedOrTodate(params.range)) {
            dispatch(clearAnalyzeData());
        }
        else {
            dispatch(clearAnalyzeData());
            dispatch(getBaleKPI(params));
        }
        return () => dispatch(clearAnalyzeData());
    }, [params]);

    return <>
        <h5 className="card-subtitle-1">Bale</h5>
        <SummaryBox>
            <SummaryRow>
                <SummaryItem title="Bales" isLoading={isRequesting} value={summary.bales} />
                <SummaryItem title="Avg. Bale Time" isLoading={isRequesting} value={toDisplayTimeString(summary.avg_bale_time)} />
            </SummaryRow>
        </SummaryBox>
    </>;
};

export default AnalyzeInfoThree;